import { routes } from "~/constants";

export const getIsActive = (path: string, to: string) => {
  if (!to) return false;
  if (to === routes.root) return path === to;
  return path.includes(to);
};
